import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@cw-ui/form-components';
import { Label, formatMessage } from 'cw-ui-core';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import css from 'src/styles/App.scss';
import Locale from 'src/i18n';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    // height: '100%',
    flexDirection: 'column',
}));

const svgPath = '/images/error-message-light.svg';

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <>
            <div className={css.bannerContainer}>
                <Label value={formatMessage(Locale.ssoAppTitle)} className={css.appTitle} />
            </div>
            <StyledBox>
                <Typography
                    variant="h5"
                    sx={{
                        marginBottom: 2,
                    }}>
                    Something went wrong!
                </Typography>
                <img src={svgPath} alt="Error" style={{ height: 'auto' }} />
                <pre
                    style={{
                        marginTop: 16,
                        marginBottom: 16,
                    }}>
                    {error.message}
                </pre>
                <Button variant="primary" onClick={resetErrorBoundary}>
                    Try again
                </Button>
            </StyledBox>
        </>
    );
}

export default ErrorFallback;
